/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod7_BadgeInputs */

const es_landing_mod7_badge = /** @type {(inputs: Landing_Mod7_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista Séptima`)
};

const gl_landing_mod7_badge = /** @type {(inputs: Landing_Mod7_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista Sétima`)
};

const en_landing_mod7_badge = /** @type {(inputs: Landing_Mod7_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seventh List`)
};

/**
* | output |
* | --- |
* | "Seventh List" |
*
* @param {Landing_Mod7_BadgeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod7_badge = /** @type {((inputs?: Landing_Mod7_BadgeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod7_BadgeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod7_badge(inputs)
	if (locale === "en") return en_landing_mod7_badge(inputs)
	return es_landing_mod7_badge(inputs)
});